import * as React from "react";
import { merge } from "glamor";
import classNames from "classnames";

interface IProps {
    card: boolean;
    list: boolean;
}

const BulkDragPreview: React.FC<IProps> = (props) => {
    const { card, list } = props;

    const styles = React.useMemo(() => {
        return merge({
            transform: "translate(12px, 12px)",
            boxShadow: "rgba(0, 0, 0, 0.16) 0px 2px 6px, rgba(0, 0, 0, 0.24) 0px 3px 6px !important",
        });
    }, []);

    return <div {...styles} className={classNames("item", { card, list })}></div>;
};

export default BulkDragPreview;
